/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EntityType {
  UNAVAILABILITY = 'unavailability',
  PRIVATE_SLOT = 'private_slot',
  NOTE = 'note',
  USER_AVAILABILITY = 'user_availability',
  EVENT = 'event',
}
